// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__YOtX0","title":"Info_title__moJ8o","selects":"Info_selects__1dVhK","requiredAsterisk":"Info_requiredAsterisk__1DEg5"};